<template lang="pug">
Button(
  @click="openConfirm($event)"
  v-bind="attrs"
)

//- ConfirmPopup  - shows up right next to the button
//- ConfirmDialog - shows a popup dialog in the center of the screen
//- ConfirmPopup
ConfirmDialog(:group="`confirm-button-dialog-${id}`")
  template(#message="slotProps")
    //- Callers can pass rich dialog content via the default slot
    //- (e.g. a UserAvatar). Falls back to the string `confirmMessage`.
    slot
      .flex.flex-column.align-items-center.w-full.gap-5.max-w-screen-sm
        i.text-5xl.text-primary-500(v-if="slotProps.message.icon" :class="slotProps.message.icon")
        .card.flex-center.w-full
          .p-confirm-dialog-message {{ slotProps.message.message }}
</template>

<script setup>
import { useAttrs } from 'vue'
// import ConfirmPopup from 'primevue/confirmpopup'
import ConfirmDialog from 'primevue/confirmdialog'
import { useConfirm } from "primevue/useconfirm";
// import { useToast } from "primevue/usetoast";

// Override confirmation config with props
const props = defineProps({
  confirmHeader:  {type: String, default: "Please Confirm" },
  confirmMessage: {type: String, default: "Are you sure you want to proceed?" },
  confirmIcon:    {type: String, default: null },
  confirmButtonLabel: {type: String, default: 'Confirm' },
  rejectButtonLabel:  {type: String, default: 'Cancel' },
  acceptClass:    {type: String, default: 'p-button-sm p-button-danger' },
  rejectClass:    {type: String, default: 'p-button-sm p-button-secondary p-button-outlined' },
  id:             {type: Number, default: Date.now() },
})

const attrs   = useAttrs()
const confirm = useConfirm()
const emit    = defineEmits(['onAccept', 'onReject'])
// const toast   = useToast()

function openConfirm(event) {
  confirm.require({
    group:        `confirm-button-dialog-${props.id}`, // setting the group ensures we select the correct component
    target:       event.currentTarget,
    message:      props.confirmMessage,
    icon:         props.confirmIcon,
    acceptLabel:  props.confirmButtonLabel,
    rejectLabel:  props.rejectButtonLabel,
    acceptClass:  props.acceptClass,
    rejectClass:  props.rejectClass,
    // callback methods
    accept:       onAccept,
    reject:       onReject,
    // the header only shows up on ConfirmDialog (no header in ConfirmPopup)
    header:       props.confirmHeader,
  })
}

function onAccept() {
  // toast.add({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 })
  emit('onAccept')
}

function onReject() {
  // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 })
  emit('onReject')
}
</script>

<style lang="scss">
.p-confirm-dialog-message {
  white-space: pre-line;
}
</style>
